import { useTranslation } from 'react-i18next';
import { Box, Flex, Heading, Text, TextArea } from '@radix-ui/themes';
import { Callout } from '@/components/common';
import { WizardScreen } from '@/components/layout';
import { ContinueButton, OnboardingWizardHeader } from '@/components/onboarding';
import { useOnboardingStore } from '@/stores/onboardingStore';
import { monoCounterStyle } from './styles';
import type { OnboardingStepProps } from './types';
import { useSaveAndNext } from './useSaveAndNext';

const MAX_BIO = 300;

export function AboutStep({ flow }: OnboardingStepProps) {
  const { t } = useTranslation('onboarding');
  const bio = useOnboardingStore(state => state.bio);
  const setBio = useOnboardingStore(state => state.setBio);
  const saveAndNext = useSaveAndNext(flow);

  return (
    <WizardScreen header={<OnboardingWizardHeader flow={flow} onSkip={flow.skip} />}>
      <Flex direction="column" gap="4" py="2" pb="5">
        <Heading size="5" weight="light">
          {t('steps.about.title')}{' '}
          <Text size="1" color="gray" as="span">
            {t('steps.about.optional')}
          </Text>
        </Heading>
        <Callout>{t('steps.about.callout')}</Callout>
        <Box position="relative">
          <TextArea
            value={bio}
            onChange={e => setBio(e.target.value.slice(0, MAX_BIO))}
            placeholder={t('steps.about.placeholder')}
            data-testid="onboarding-bio"
            rows={5}
            maxLength={MAX_BIO}
          />
          <Text
            size="1"
            color="gray"
            style={{
              position: 'absolute',
              right: 10,
              bottom: 10,
              ...monoCounterStyle,
              pointerEvents: 'none',
            }}
          >
            {t('steps.about.counter', { count: bio.length })}
          </Text>
        </Box>
        <ContinueButton onClick={saveAndNext}>{t('actions.continue')}</ContinueButton>
      </Flex>
    </WizardScreen>
  );
}
